<style scoped>
.br-10 {
  border-radius: 10px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}
</style>

<template>
  <v-container fluid>
    <v-alert v-if="error" id="error" :value="error !== null" class="br-10 dark font-weight-medium" type="error" dismissible>{{ error.message | uppercase }}</v-alert>
    <!-- <v-layout justify-center class="pb-3" style="cursor: pointer;">
      <v-flex xl6 lg6 md8 sm10 xs12 >
        <v-list two-line class="br-10 elevation-3 lighten-4 blue-grey--text text--darken-3" color="blue">
        <v-list two-line class="br-10 elevation-3 pink lighten-4 blue-grey--text text--darken-3" color="blue" @click.native="$router.push('/license/form')">
          <v-list-item>
            <v-list-item-action>
              <img width="65" src="img/cards/coming-soon.png">
              <img width="65" src="img/cards/new.png">
              <img width="50" height="50" src="img/cards/checked.png">
            </v-list-item-action>
            <v-list-item-content class="pl-2">
              <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('license_application_council') }}</v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout> -->
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-card color="blue lighten-4" class="br-10 elevation-3">
            <v-list two-line class="br-10 elevation-0 lighten-4 black--text" color="blue" @click.native="menu1 = !menu1; checkmenu2()">
              <v-list-item>
                <v-list-item-action>
                  <div style="max-height: 50px">
                    <img width="50" src="img/cards/checked.png">
                  </div>
                </v-list-item-action>
                <v-list-item-content class="pl-2">
                  <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('page_license.index.header') }}</v-card>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon style="font-size: 20px;" v-if="!menu1" color="primary">fa-chevron-circle-down</v-icon>
                  <v-icon style="font-size: 20px;" v-if="menu1" color="primary">fa-chevron-circle-up</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-form v-if="menu1" @submit.prevent="searchData()">
              <v-divider></v-divider>
              <div class="pa-3 pr-4 pl-4">
                <span class="caption"><strong>{{ $t('page_license.index.hintlicense') }}</strong></span>
                <v-text-field :value="data.searchId" @input="patchData({ searchId: $event })" :label="$t('searches')"/>
                <span class="caption"><strong>{{ $t('page_license.index.hint') }}</strong></span><br>
                <v-layout reverse row class="mt-2 pa-5">
                  <v-btn :disabled="data === {} || data.searchId === undefined || data.searchId === ''" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn>
                </v-layout>
              </div>
            </v-form>
          </v-card>
        </v-flex>
    </v-layout>
    <v-layout justify-center v-if="listData.length > 0">
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-list three-line class="br-10 elevation-3">
          <v-subheader class="black--text"><h3>{{ $t('page_license.index.result') }}</h3></v-subheader>
          <v-divider/>
          <div v-for="item in listData" :key="item.account_reference">
            <v-list-item ripple style="cursor: pointer;">
              <v-list-item-action class="pl-2 pt-2">
                <v-checkbox :value="item.account_reference" :input-value="data._id" @click.native="setData({ data: { _id: item.account_reference, type: item.account_module } })"/>
              </v-list-item-action>
              <v-list-item-content @click.stop="setData({ data: { _id: item.account_reference, type: item.account_module } })">
                <v-list-item-title class="body-2"><strong>{{ $t('page_license.index.license_permit_no') }} : {{ item.info.license_no }}</strong></v-list-item-title>
                <v-list-item-subtitle><h4>{{ $t('page_license.index.m_kod_type') }} : {{ item.info.business_type | capitalize }}</h4></v-list-item-subtitle>
                <v-list-item-subtitle class="ellipsis"><h4>{{ $t('page_license.index.name') }} : {{ hideText(item.info.business_name) | capitalize }}</h4></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-layout reverse row class="pa-5">
            <v-btn :disabled="data._id === undefined || data._id === ''" @click="redirect()" class="mt-3" color="primary" large nuxt align-right rounded>{{ $t('page_assessment.index.proceed') }}</v-btn>
          </v-layout>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  beforeDestroy () {
    this.$store.commit('search/setError', { error: null })
    this.$store.commit('search/setLoading', { loading: false })
  },
  beforeMount () {
    this.$store.commit('search/setListData', { listData: [] })
  },
  computed: {
    ...mapState({
      data: state => state.search.data,
      form: state => state.search.form,
      error: state => state.search.error,
      listData: state => state.search.listData
    })
  },
  data () {
    return {
      menu1: true,
      menu2: false
    }
  },
  methods: {
    ...mapActions({
      patchData: 'search/patchData',
      resetData: 'search/resetData',
      searchData: 'search/searchData',
      searchID: 'search/searchID'
    }),
    ...mapMutations({
      setData: 'search/setData',
      setForm: 'search/setForm'
    }),
    checkmenu1 () {
      this.menu2 = !this.menu2
      if (this.menu2 === true) {
        this.menu1 = false
      }
    },
    checkmenu2 () {
      if (this.menu1 === true) this.menu2 = false
    },
    redirect () {
      return this.$router.push({ name: 'license-id', params: { id: btoa(this.data._id) }, query: { type: this.data.type } })
    },
    searchOperationApplication: async function ($event) {
      const response = await this.searchID()
      if (response) {
        this.$router.push(`/license/preview/${btoa(response._id)}`)
        this.setForm({ form: { id: '' } })
      }
      await this.resetData()
    },
    hideText (text) {
      if (!text || text.length === 0) return ''
      var t = text
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    }
  }
}
</script>
